import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import styled from 'styled-components';
import StringFormatter from '../utils/StringFormatter';
import PermissionControlledComponent from './PermissionControlledComponent';
import FeatureControlledComponent from "./FeatureControlledComponent";
const BaseLink = ({ className, updateBrowserLocation, children, ...rest }) => {
    // TODO ADD I18N
    const outputText = StringFormatter(rest.text, rest.parameters);
    return React.createElement(FeatureControlledComponent, { requireFeature: rest.requireFeature },
        React.createElement(PermissionControlledComponent, { requireAllDirectPermissions: rest.requireAllDirectPermissions, requireOneDirectPermission: rest.requireOneDirectPermission },
            React.createElement(LinkContent, { className: className, onClick: updateBrowserLocation, ...rest },
                outputText,
                children)));
};
const LinkContent = styled(ReactRouterLink) `
  font-family: ${props => props.theme.fonts.medium};
  font-size: 14px;
  color: ${props => props.theme.colors.anchorText};

  text-decoration: none;
`;
export default BaseLink;
//# sourceMappingURL=BaseLink.js.map